<template>
  <div>
    <v-btn icon small @click="replyComment">
      <v-icon :size="size === 'large' ? '20' : '16'" color="#828282"
        >fal fa-message</v-icon
      >
    </v-btn>
    <span
      :class="[size === 'large' ? 'text-md-subtitle-2 body-2' : 'caption']"
      class="grey--text"
    >
      {{ count }} <translate>Comments</translate>
    </span>
  </div>
</template>
<script>
export default {
  name: "ButtonComment",
  props: ["size", "count"],
  data: () => ({}),
  computed: {},
  methods: {
    replyComment() {
      this.$emit("replyComment");
    },
  },
};
</script>